import { HJPromise } from "../utils/hjPromise";
// 业务咨询
export function programAnsAdd(data) {
    return HJPromise({
        url: '/ask/new',
        type: 'post',
        data
    });
}
